import { render } from "./MenuMobileBolhas.vue?vue&type=template&id=27911960&scoped=true&ts=true"
import script from "./MenuMobileBolhas.vue?vue&type=script&lang=ts"
export * from "./MenuMobileBolhas.vue?vue&type=script&lang=ts"

import "./MenuMobileBolhas.vue?vue&type=style&index=0&id=27911960&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27911960"]])

export default __exports__